"use client";

import styled from "styled-components";
import { Placeholder } from "@lmn/design-system";
import media from "@/styles/mediaQueries";

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  overflow: hidden;

  ${media.screenSmMin`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      "main main small1 small2"
      "main main small3 small4";
  `}
`;

const SkeletonSlot = styled.div<{ $area: string; $isMain?: boolean }>(
  ({ theme, $area, $isMain }) => ({
    flexShrink: 0,
    width: "290px",
    height: "300px",
    overflow: "hidden",
    backgroundColor: theme.kallisto.color.background.static.backgroundLayer01,
    gridArea: $area,
    borderRadius: theme.kallisto.border.radius.radius100,

    ...media.screenXsMin({
      width: "340px",
      height: "300px",
    }),

    ...media.screenSmMin({
      width: "100%",
      height: $isMain ? "264px" : "128px",
    }),

    ...media.screenLgMin({
      height: $isMain ? "400px" : "196px",
    }),
  })
);

const GRID_AREAS = ["main", "small1", "small2", "small3", "small4"];

export default function ImageGallerySkeleton() {
  return (
    <SkeletonContainer>
      {GRID_AREAS.map((area, index) => (
        <SkeletonSlot key={area} $area={area} $isMain={index === 0}>
          <Placeholder width="100%" height="100%" borderRadius="radiusNone" />
        </SkeletonSlot>
      ))}
    </SkeletonContainer>
  );
}
